import {clone} from '@/lib/helper/helper'
import {EventBus} from '@/events/eventBus'

export const handleSocketPosMenuItemUpdate = (command, data) => {
  if (data?.action === 'update') {
    window.callAS(command, {
      action: data?.action || 'update',
      menus : data?.menus || []
    }, window.SocketCommand.Menu.PosItem)
  } else if (data?.action === 'delete') {
    deletePosMenuItems(data)
  } else if (data?.action === 'stock_increment') {
    incrementPosMenuItemsQuantityById(data)
  } else if (data?.action === 'stock_decrement') {
    decrementPosMenuItemsQuantityById(data)
  }
}

export const updatePosMenuItem = (item) => {
  const menu = getPosMenu()
  const items = menu?.items || []

  items.forEach(category => {
    const index = category.Items.findIndex(menuItem => menuItem.Id === item.Id)
    if (index > -1) category.Items[index] = item
  })

  setPosMenu(menu)
}

export const deletePosMenuItem = (id) => {
  const menu = getPosMenu()
  const items = menu?.items || []

  items.forEach(category => {
    const index = category.Items.findIndex(menuItem => menuItem.Id === id)
    if (index > -1) category.Items.splice(index, 1)
  })

  setPosMenu(menu)
}

export const deletePosMenuItems = (data) => {
  if (Array.isArray(data?.menus) && data?.menus?.length) {
    data.menus.forEach(menu => {
      deletePosMenuItem(menu.id)
    })
  }
}

export const decrementPosMenuItemQuantityById = (id, value = 1) => {
  const menu = getPosMenu()
  const items = menu?.items || []
  items.forEach(category => {
    const index = category.Items.findIndex(menuItem => menuItem.Id === id)
    if (index > -1) {
      category.Items[index].Quantity -= value
      category.Items[index].DetailsData.StockQuantity -= value
    }
  })

  setPosMenu(menu)
}
export const decrementPosMenuItemsQuantityById = (data) => {
  const menus = data?.menus || []

  if (Array.isArray(menus) && menus?.length) {
    menus.forEach(menu => {
      decrementPosMenuItemQuantityById(menu.id, menu.value)
    })
  }
}

export const incrementPosMenuItemQuantityById = (id, value = 1) => {
  const menu = getPosMenu()
  const items = menu?.items || []

  items.forEach(category => {
    const index = category.Items.findIndex(menuItem => menuItem.Id === id)
    if (index > -1) {
      category.Items[index].Quantity += value
      category.Items[index].DetailsData.StockQuantity += value
    }
  })

  setPosMenu(menu)
}
export const incrementPosMenuItemsQuantityById = (data) => {
  const menus = data?.menus || []

  if (Array.isArray(menus) && menus?.length) {
    menus.forEach(menu => {
      incrementPosMenuItemQuantityById(menu.id, menu.value)
    })
  }
}

export const getPosMenu = () => {
  return clone(window.posMenu)
}

export const setPosMenu = (menu) => {
  menu.items = fixDisabledMenuOptions(menu.items)
  window.posMenu = menu
  EventBus.$emit(window.SocketCommand.Menu.PosUpdate)
}

const fixDisabledMenuOptions = (items) => {
  const categories = items || []

  for (let c = 0; c < categories.length; c++) {
    const products = categories[c]?.Items || []

    for (let m = 0; m < products.length; m++) {
      const product = products[m]

      if (product.Active) {
        let options = product?.DetailsData?.Options || []

        if (!Array.isArray(options)) {
          options = Object.keys(options).map((k) => options[k])
        }

        for (let i = 0; i < options.length; i++) {
          const option = options[i]
          const optionIsRequired = option.Required && option.DisplayType === 'checkbox'
          const allOptionOptionValuesDisabled = option.OptionValues?.every(ov => ov.Disabled)
          if (allOptionOptionValuesDisabled) option.Disabled = true

          const optionIsDisabled = option.Disabled || allOptionOptionValuesDisabled

          if ((optionIsRequired && optionIsDisabled) || (option.DisplayType === 'radio' && optionIsDisabled)) {
            product.Status = false
            option.Disabled = true
            option.Required = false
          }

          if (option.Disabled) option.Required = false

          for (let ii = 0; ii < option.OptionValues.length; ii++) {
            const optionValue = option.OptionValues[ii]

            if (option.Disabled || optionValue.Disabled) {

              if (option.DisplayType === 'radio') {
                if (option.DefaultValueId?.toString() === optionValue.Id?.toString()) {
                  option.DefaultValueId = option.OptionValues.find(ov => !ov.Disabled)?.Id
                }
              }

              if (option.DisplayType === 'checkbox') {
                if (optionValue.Mandatory && optionValue.Selected) product.Status = false
              }

              optionValue.Selected = false
              optionValue.Required = false
            }
          }
        }
      }
    }
  }

  return categories
}
